/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref, shallowRef } from 'vue';
import { defineStore } from 'pinia';

import { ModalCode } from './ModalCode';
import { modalRegistry } from './registry';

export const useModal = defineStore('modal', () => {
    const activeModalCode = ref<ModalCode>();
    const activeModal = shallowRef<any>();
    const modalData = ref<any>();
    const afterSubmitRef = ref<() => void>();

    async function showModal(code: ModalCode, data?: any, afterSubmit?: () => void) {
        activeModalCode.value = code;
        activeModal.value = modalRegistry[code];
        modalData.value = data;
        afterSubmitRef.value = afterSubmit;
    }

    function hideModal(...codes: ModalCode[]) {
        const currentCode = activeModalCode.value;
        if (codes.length === 0 || (currentCode != null && codes.includes(currentCode))) {
            activeModal.value = undefined;
            modalData.value = undefined;
            afterSubmitRef.value = undefined;
        }
    }

    return {
        activeModal,
        activeModalCode,
        modalData,
        afterSubmitRef,
        showModal,
        hideModal,
    };
});
